import Dialog, {DialogCloseEventArgs} from "../../1. Core/Controls/Dialog/Dialog";
import NP from "../../1. Core/NP";
import Delegate from "../../1. Core/Delegate";
import Control from "../../1. Core/Control";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import DropPanel from "../../1. Core/Controls/DropPanel/DropPanel";
import Calendar from "../../1. Core/Controls/Calendar/Calendar";
import {clearAllTournaments, ITournament} from "../../10. Battle/Util";
import CheckBox from "../../1. Core/Controls/CheckBox/CheckBox";

let moment = require('moment');
import './TournamentDlg.scss';
import {SportType} from "../../10. Battle/types";
import Select from "../../1. Core/Controls/Select/Select";
import ImageTextField from "../../1. Core/Controls/TextField/ImageTextField";
import Button from "../../1. Core/Controls/Button/Button";
import TVStreamListDialog from "../../10. Battle/TEvents/TVStreamListDialog";

export default class TournamentDlg extends Dialog {

	public EvTournamentEdited: Delegate;

	private _Tournament: ITournament;
	private _Date: Date | null;
	private _nameTb: Control;
	private _placeTb: Control;
	private _dateInput: TextField;
	private _inRaitingCheckBox: CheckBox;
	private _isProCheckBox: CheckBox;
	private _typeSelect: Select;
	private _logoUrlInput: ImageTextField;
	private _current: TextField;
	private _tvStreamUrl: string;

	constructor(settings?: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{

		this.EvTournamentEdited = new Delegate();
		this._Date = null;
		this._Tournament = null;
		this._tvStreamUrl = '';

		super._initFields(settings);

		if (this._Tournament)
		{
			let date = this._Tournament.Date;
			if (date)
				this._Date = moment(date).toDate();
			this._tvStreamUrl = this._Tournament.TVStreamUrl || '';
		}
		this._Caption = NP.RM.getString(this._Tournament ? 'Edit tournament' : 'Create tournament');
		this._ShowHeader = true;
		this.EvOkButtonClick.add(this._onTournamentDlgOkButtonClick, this);
	}

	_render()
	{
		super._render();

		this.addClass('tournament-dlg');
		NP.addCssClass(this._contentNode, "tournament-dlg__content");


		this._nameTb = new TextField({
			ParentNode: this._contentNode,
			Value: this._Tournament ? this._Tournament.Name : '',
			FloatingLabel: NP.RM.getString("Name")
		});

		this._current = new TextField({
			ParentNode: this._contentNode,
			Value: this._Tournament ? this._Tournament.Current : '',
			FloatingLabel: 'Current'
		});

		this._typeSelect = new Select({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Type'),
			SelectedIndex: 1,
			Items: [
				{Content: 'Boxing', Value: SportType.Box},
				{Content: 'MMA', Value: SportType.MMA},
				{Content: 'Kickboxing', Value: SportType.KB}
			]
		});

		this._logoUrlInput = new ImageTextField({
			ParentNode: this._contentNode,

			TextFieldSettings: {
				FloatingLabel: NP.RM.getString('LogoUrl')
			},
			EvChanged: () =>
			{
				this._Tournament.LogoUrl = this._logoUrlInput.getValue();
			}
		});

		this._logoUrlInput.setValue(this._Tournament ? this._Tournament.LogoUrl : '');

		this._placeTb = new TextField({
			ParentNode: this._contentNode,
			Value: this._Tournament ? this._Tournament.Place : '',
			FloatingLabel: NP.RM.getString("Place")
		});

		this._dateInput = new TextField({
			ParentNode: this._contentNode,
			ShowDeleteButton: true,
			FloatingLabel: NP.RM.getString('Date'),
			FontImage: NP.FontImages.event,
			EnabledEdit: false,
			Value: this._Date ? moment(this._Date).format(NP.getDayFormat()) : '',
			EvDeleteClick: (textField: TextField) =>
			{
				this._Date = null;
				textField.setValue('');
			},
			EvFocus: (sender: TextField) => this._showCalendar(sender)
		});

		let inRaitingContainer = NP.createNode(this._contentNode, 'tournament-dlg__check-box-container');
		this._inRaitingCheckBox = new CheckBox({
			Class: "tournament-dlg__check-box",
			ParentNode: inRaitingContainer,
			Content: NP.RM.getString('UserInRaiting'),
			Checked: this._Tournament ? this._Tournament.UserInRaiting : false,
		});

		let isProContainer = NP.createNode(this._contentNode, 'tournament-dlg__check-box-container');
		this._isProCheckBox = new CheckBox({
			Class: "tournament-dlg__check-box",
			ParentNode: isProContainer,
			Content: NP.RM.getString('IsPro'),
			Checked: this._Tournament ? this._Tournament.IsPro : false,
		});

		new Button({
			ParentNode: this._contentNode,
			Content: 'TV/Stream (promotion default)',
			EvClick: () => {
				new TVStreamListDialog({
					TVStreamData: this._tvStreamUrl,
					EvOkButtonClick: (dlg, args: { Value: string }) => {
						this._tvStreamUrl = args.Value;
					},
				}).show();
			},
		});
	}

	async _onTournamentDlgOkButtonClick(sender: object, args: DialogCloseEventArgs)
	{
		let current = this._current.getValue()
		if (current && !current.startsWith("current"))
		{
			NP.showMessage({Content: 'Current must start with "current"'});
			args.IsCancelClose = true
			return
		}


		args.IsCancelClose = true;
		let nameText = this._nameTb.getValue();
		if (nameText)
		{
			let placeText = this._placeTb.getValue();
			let tournament: ITournament = {
				...this._Tournament,
				Name: nameText,
				Date: this._Date ? moment(this._Date).format('YYYY-MM-DD HH:mm:ss.S') : null,
				Place: placeText,
				UserInRaiting: this._inRaitingCheckBox.getChecked(),
				// PermissionId?: number;
				IsPro: this._isProCheckBox.getChecked(),
				Type: this._typeSelect.getValue(),
				Current: this._current.getValue(),
				TVStreamUrl: this._tvStreamUrl || null,
			};

			if (this._Tournament)
			{
				await ServerAPI.post(`/tournaments/${this._Tournament.Id}`, tournament)
			}
			else
			{
				await ServerAPI.post(`/tournaments`, tournament)
				clearAllTournaments()
			}

			this.EvTournamentEdited.fire(this);
			this.hide();
		}
	}

	_showCalendar(textField: TextField)
	{
		let dropPanel = new DropPanel({
			AutoClose: true,
			EnableResize: false,
			Content: new Calendar({
				Value: this._Date || moment().toDate(),
				EvDateChanged: (calendar: Control) =>
				{
					this._Date = calendar.getValue();
					textField.setValue(moment(this._Date).format(NP.getDayFormat()));
					dropPanel.destroy();
				},
			})
		});
		NP.showDropPanel(dropPanel, textField.getRoot(), NP.LTRB.Bottom, undefined, true);
	}
}
